import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[optSiteFooter]'
})
export class SiteFooterDirective {

    constructor(public viewContainerRef: ViewContainerRef) { }

}
